var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info_container history"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("ACT-Chain transaction History")]), _c('canvas', {
    ref: "transaction_graph",
    staticClass: "transaction_graph"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }